var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"my-td2-box",class:{'td2-body-bg':_vm.tdType == 'body'},style:('width:' + _vm.boxWidth + 'px;')},[_c('div',{ref:"td",staticClass:"my-td2-box-inner",class:{'overflow':_vm.overflow}},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }